export const localeInfo = (
  locale: string,
): { language: string; country: string } => ({
  language: locale.split('-')[0],
  country: locale.split('-')[1],
});
